export default () => {
    const signupBtns = document.querySelectorAll('.signupBtn');
    const signupForm = document.querySelector('.cta__signup');
    const close = document.querySelector('.signUpPopup__close')
  
    if (signupBtns.length) {
        signupBtns.forEach(signupBtn => {
            signupBtn.addEventListener('click', () => {
                signupForm.classList.add('active');
            });
        });
    }

    if(close) {
        close.addEventListener('click', () => {
            signupForm.classList.remove('active');
        });
    }
  };
  